import { InternalError } from './internal.error';
import { isTransientNetworkFetchError } from './network-fetch-error.util';

type SanitizedRequestErrorPayload = {
  error: unknown;
  status: number | null;
  data?: Record<string, unknown>;
};

/**
 * Preserves network classification without retaining raw errors or response bodies.
 * Pass the actual response status (null when absent), never an InternalError's fallback status.
 * The caller must provide a safe message and allowlisted context in data.
 */
export class SanitizedRequestError extends InternalError {
  constructor(message: string, { error, status, data }: SanitizedRequestErrorPayload) {
    const isNetworkFailure = status === null && isTransientNetworkFetchError(error);

    super(message, {
      status,
      error: isNetworkFailure ? new TypeError('Failed to fetch') : undefined,
      data,
    });
  }
}
